export enum EOrderDetailWidget {
	SPLITS = 'splits',
	RETURNS = 'returns',
	DISCOUNTS = 'discounts',
	VAT_CORRECTIONS = 'vat_corrections',
	ERROR_CORRECTION = 'error_correction',
	SWISS_DECLARATIONS = 'swiss_declarations',
	DELIVERY_INFORMATION = 'delivery_information',
	AMOUNT_BREAKDOWN = 'amount_breakdown',
}

export const ORDER_DETAIL_WIDGETS: { key: EOrderDetailWidget; label: string }[] = [
	{ key: EOrderDetailWidget.SPLITS, label: 'Order Splits' },
	{ key: EOrderDetailWidget.RETURNS, label: 'Returns' },
	{ key: EOrderDetailWidget.DISCOUNTS, label: 'Discounts' },
	{ key: EOrderDetailWidget.VAT_CORRECTIONS, label: 'VAT Corrections' },
	{ key: EOrderDetailWidget.ERROR_CORRECTION, label: 'Error Correction' },
	{ key: EOrderDetailWidget.SWISS_DECLARATIONS, label: 'Swiss Declarations' },
	{ key: EOrderDetailWidget.DELIVERY_INFORMATION, label: 'Delivery Information' },
	{ key: EOrderDetailWidget.AMOUNT_BREAKDOWN, label: 'Amount Breakdown' },
];

export type TOrderDetailWidgetsVisibility = Record<EOrderDetailWidget, boolean>;

export const DEFAULT_WIDGETS_VISIBILITY = ORDER_DETAIL_WIDGETS.reduce(
	(acc, { key }) => ({ ...acc, [key]: true }),
	{} as TOrderDetailWidgetsVisibility,
);

export const WIDGETS_VISIBILITY_STORAGE_KEY = 'orderDetailWidgetsVisibility';
